export default __webpack_public_path__ + "static/media/logo.a1b44e31.svg";